import { render, staticRenderFns } from "./TwelveCol.vue?vue&type=template&id=6ca42ee2"
import script from "./TwelveCol.vue?vue&type=script&lang=js"
export * from "./TwelveCol.vue?vue&type=script&lang=js"
import style0 from "./TwelveCol.vue?vue&type=style&index=0&id=6ca42ee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports